/**
 * /frontend/src/features/analytics/components/appointments/ServiceTypeDistribution.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import DistributionPieChart from '../charts/DistributionPieChart';

/**
 * Appointment service type distribution.
 * @param {{data:Array<{name:string,value:number}>}} props
 * @returns {JSX.Element}
 */
const ServiceTypeDistribution = ({ data }) => (
  <ChartContainer title="Service Type Distribution" subtitle="Booked appointments by service">
    <DistributionPieChart data={data} nameKey="name" valueKey="value" />
  </ChartContainer>
);

export default ServiceTypeDistribution;

